<template>
    <div class="dropzone mb-3 dz-clickable dropzone-single">
        <div class="fallback">
            <div class="custom-file">
                <input type="file" class="custom-file-input">
                <label class="custom-file-label">
                    {{ $t('common.choose-file') }}
                </label>
            </div>
        </div>
        <div class="dz-preview dz-preview-single"
                :class="previewClasses"
                ref="previewSingle">
            <div class="dz-preview-cover"
                    :class="innerPreviewClasses">
                <img class="dz-preview-img"
                     :class="imagePreviewClasses"
                     data-dz-thumbnail
                >
            </div>
        </div>
    </div>
</template>

<script>
    import Dropzone from 'dropzone'

    export default {

        model: {
            prop: 'value',
            event: 'change'
        },

        props: {
            value: [File],
            options: {
                type: Object,
                default: () => ({})
            },
            url: {
                type: String,
                default: 'http://'
            },
            formData: {
                type: Object,
                default: () => {}
            },
            previewClasses: [String, Object, Array],
            innerPreviewClasses: [String, Object, Array],
            imagePreviewClasses: [String, Object, Array]
        },
        
        data() {
            return {
                currentFile: null,
                dropzone: null,
            }
        },
        
        methods: {

            setFormData(file, xhr, formData) {
                formData.append("_token", this.$auth['csrf-token']);
                for (let prop in this.formData) {
                    // Workaround to not send null values as strings!
                    if (this.formData[prop] !== null) {
                        formData.append(prop, this.formData[prop]);
                    }
                }
            },

            async initDropzone() {
                //let Dropzone = await import('dropzone')
                //Dropzone = Dropzone.default || Dropzone
                Dropzone.autoDiscover = false
                let preview = this.$refs.previewSingle;
                let self = this
                let finalOptions = {
                    ...this.options,
                    url: this.url,
                    previewsContainer: preview,
                    previewTemplate: preview.innerHTML,
                    maxFiles: 1,
                    sending: this.setFormData,
                    init: function () {
                        this.on("addedfile", function (file) {
                            if (self.currentFile) {
                                this.removeFile(self.currentFile);
                            }
                            self.currentFile = file;
                        })
                    },
                }
                this.dropzone = new Dropzone(this.$el, finalOptions)
                preview.innerHTML = ''
                let evtList = ['addedfile', 'error', 'success', 'complete']
                evtList.forEach(evt => {
                    this.dropzone.on(evt, (...args) => {
                        // We put the file in the queue again to let retry the upload when needed.
                        if (evt === 'error') {
                            args[0].status = Dropzone.QUEUED
                        }
                        // We pass the event with the dropzone object to the parent.
                        this.$emit(evt, { args, dropzone: this.dropzone });
                        // We update the associated model.
                        if (evt === 'addedfile') {
                            this.$emit('change', this.currentFile);
                        }
                    })
                })
                // Here we could use the `thumbnail` event and change the preview zone ratio.
                // Real image size is this.currentFile.width x this.currentFile.height.
                // The preview zone can be targeted with JQuery. 
            }
        },

        async mounted() {
            this.initDropzone()
        }
    }
</script>

<style scoped>

    .dropzone >>> .dz-message {
        padding: 3.8rem 1rem;
    }
    .dropzone >>> .dz-message .dz-button {
        background: hsla(0,0%,100%,0);
        border: none;
        color: #8898aa;
    }

</style>
